import Vue from 'vue'
import App from './App.vue'
import VueRouter from 'vue-router';

import VueGeolocation from 'vue-browser-geolocation';

Vue.use(VueRouter);

Vue.use(VueGeolocation);
Vue.config.productionTip = false

/*
Router configuration
 */
const router = new VueRouter({
    mode: 'history',
    /*
    We just add one route
     */
    routes: [{
        // Wildcard path
        path: '*',
        component: App,
        props: (route) => ({
            type: route.query.type,
            subtype: route.query.subtype
        })
    }]
});


new Vue({
    router,
  render: h => h(App),
}).$mount('#app');
